import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("gos_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const COUNTRY_RATES_TO_CAD = {
  CAD: 1, USD: 1.36, EUR: 1.48, GBP: 1.72,
  AED: 0.37, SAR: 0.36, INR: 0.016, PKR: 0.0048,
  IDR: 0.000084, ARS: 0.0014,
};

export function convertAmount(amount, fromCcy, toCcy) {
  if (!amount || fromCcy === toCcy) return amount;
  const inCad = amount * (COUNTRY_RATES_TO_CAD[fromCcy] || 1);
  const rate = COUNTRY_RATES_TO_CAD[toCcy] || 1;
  return inCad / rate;
}

export function formatMoney(amount, currency) {
  if (amount === 0 || amount === "0") return `${currency} 0`;
  if (!amount && amount !== 0) return "—";
  const opts = { maximumFractionDigits: ["IDR", "ARS"].includes(currency) ? 0 : 2 };
  try {
    return new Intl.NumberFormat("en-US", { style: "currency", currency, ...opts }).format(amount);
  } catch (e) {
    return `${currency} ${Number(amount).toLocaleString("en-US", opts)}`;
  }
}
